import { render } from "./EntryLangSelector.vue?vue&type=template&id=827cbe84&scoped=true"
import script from "./EntryLangSelector.vue?vue&type=script&lang=ts"
export * from "./EntryLangSelector.vue?vue&type=script&lang=ts"

import "./EntryLangSelector.vue?vue&type=style&index=0&id=827cbe84&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-827cbe84"

export default script